import { render, staticRenderFns } from "./CampaignEmailReport.vue?vue&type=template&id=11b80ab9&scoped=true&"
import script from "./CampaignEmailReport.vue?vue&type=script&lang=js&"
export * from "./CampaignEmailReport.vue?vue&type=script&lang=js&"
import style0 from "./CampaignEmailReport.vue?vue&type=style&index=0&id=11b80ab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b80ab9",
  null
  
)

export default component.exports